import React from "react";
import { RoundedButton } from "@packages/ui";

const CompulsoryImageButton = ({ disabled, children }) => {
  return (
    <RoundedButton
      variant="contained"
      component="span"
      style={{ minWidth: 20, minHeight: 45 }}
      disabled={disabled}
    >
      {children}
    </RoundedButton>
  );
};

export default CompulsoryImageButton;
